import React from 'react'

// Mock implementation of Next.js Head component for use in React apps
// This allows ChirpThemeProvider to work in non-Next.js environments
const Head: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <>{children}</>
)

export default Head
